(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aurajex-pain-points"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.aurajex-pain__grid').forEach(function (grid) {
    if (!('IntersectionObserver' in window)) {
      grid.classList.add('is-visible');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });
    io.observe(grid);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aurajex-stages"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.aurajex-stages__grid').forEach(function (grid) {
    if (!('IntersectionObserver' in window)) {
      grid.classList.add('is-visible');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });
    io.observe(grid);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aurajex-stickers"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ax-sticker-viewport]').forEach(function (viewport) {
    var track = viewport.querySelector('[data-ax-sticker-track]');
    if (!track) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var speedSeconds = parseFloat(viewport.getAttribute('data-speed')) || 35;
    var halfWidth = track.scrollWidth / 2;
    var pxPerSecond = halfWidth / speedSeconds;

    var isPaused = false;
    var isDragging = false;
    var dragStartX = 0;
    var dragStartScroll = 0;
    var resumeTimer = null;
    var lastFrame = null;

    function scheduleResume(delay) {
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () {
        isPaused = false;
      }, delay);
    }

    viewport.addEventListener('mouseenter', function () {
      isPaused = true;
      scheduleResume(8000);
    });

    viewport.addEventListener('mouseleave', function () {
      if (!isDragging) scheduleResume(0);
    });

    viewport.addEventListener('pointerdown', function (event) {
      isDragging = true;
      isPaused = true;
      dragStartX = event.clientX;
      dragStartScroll = viewport.scrollLeft;
      viewport.classList.add('is-dragging');
      clearTimeout(resumeTimer);
      viewport.setPointerCapture(event.pointerId);
    });

    viewport.addEventListener('pointermove', function (event) {
      if (!isDragging) return;
      viewport.scrollLeft = dragStartScroll - (event.clientX - dragStartX);
    });

    function endDrag() {
      if (!isDragging) return;
      isDragging = false;
      viewport.classList.remove('is-dragging');
      scheduleResume(1500);
    }

    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);

    viewport.addEventListener('touchstart', function () {
      isPaused = true;
      clearTimeout(resumeTimer);
    }, { passive: true });

    viewport.addEventListener('touchend', function () {
      scheduleResume(1500);
    });

    viewport.addEventListener('wheel', function () {
      isPaused = true;
      scheduleResume(1500);
    }, { passive: true });

    function normalize() {
      if (halfWidth <= 0) return;
      if (viewport.scrollLeft >= halfWidth) {
        viewport.scrollLeft -= halfWidth;
        if (isDragging) dragStartScroll -= halfWidth;
      } else if (viewport.scrollLeft < 0) {
        viewport.scrollLeft += halfWidth;
        if (isDragging) dragStartScroll += halfWidth;
      }
    }

    viewport.addEventListener('scroll', normalize, { passive: true });

    if (reduceMotion) return;

    var scrollPos = viewport.scrollLeft;

    function step(timestamp) {
      if (lastFrame == null) lastFrame = timestamp;
      var delta = (timestamp - lastFrame) / 1000;
      lastFrame = timestamp;

      if (isPaused || isDragging) {
        scrollPos = viewport.scrollLeft;
      } else {
        scrollPos += pxPerSecond * delta;
        if (halfWidth > 0) {
          if (scrollPos >= halfWidth) scrollPos -= halfWidth;
          else if (scrollPos < 0) scrollPos += halfWidth;
        }
        viewport.scrollLeft = scrollPos;
      }
      requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aurajex-testimonials"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tmls-viewport]').forEach(function (viewport) {
    var track = viewport.querySelector('[data-tmls-track]');
    if (!track) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var speedSeconds = parseFloat(viewport.getAttribute('data-speed')) || 36;
    var halfWidth = track.scrollWidth / 2;
    var pxPerSecond = halfWidth / speedSeconds;

    var isPaused = false;
    var isDragging = false;
    var dragStartX = 0;
    var dragStartScroll = 0;
    var resumeTimer = null;
    var lastFrame = null;

    function scheduleResume(delay) {
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () {
        isPaused = false;
      }, delay);
    }

    viewport.addEventListener('mouseenter', function () {
      isPaused = true;
      // safety net: if mouseleave never fires (e.g. a stale hover state
      // left over from scroll-triggered hover revalidation), don't stay
      // paused forever
      scheduleResume(8000);
    });

    viewport.addEventListener('mouseleave', function () {
      if (!isDragging) scheduleResume(0);
    });

    viewport.addEventListener('pointerdown', function (event) {
      isDragging = true;
      isPaused = true;
      dragStartX = event.clientX;
      dragStartScroll = viewport.scrollLeft;
      viewport.classList.add('is-dragging');
      clearTimeout(resumeTimer);
      viewport.setPointerCapture(event.pointerId);
    });

    viewport.addEventListener('pointermove', function (event) {
      if (!isDragging) return;
      viewport.scrollLeft = dragStartScroll - (event.clientX - dragStartX);
    });

    function endDrag() {
      if (!isDragging) return;
      isDragging = false;
      viewport.classList.remove('is-dragging');
      scheduleResume(1500);
    }

    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);

    viewport.addEventListener('touchstart', function () {
      isPaused = true;
      clearTimeout(resumeTimer);
    }, { passive: true });

    viewport.addEventListener('touchend', function () {
      scheduleResume(1500);
    });

    viewport.addEventListener('wheel', function () {
      isPaused = true;
      scheduleResume(1500);
    }, { passive: true });

    function normalize() {
      if (halfWidth <= 0) return;
      if (viewport.scrollLeft >= halfWidth) {
        viewport.scrollLeft -= halfWidth;
        if (isDragging) dragStartScroll -= halfWidth;
      } else if (viewport.scrollLeft < 0) {
        viewport.scrollLeft += halfWidth;
        if (isDragging) dragStartScroll += halfWidth;
      }
    }

    viewport.addEventListener('scroll', normalize, { passive: true });

    if (reduceMotion) return;

    // scrollLeft is rounded to a whole pixel by the browser, and each
    // frame's share of the movement is well under 1px, so reading it back
    // and re-adding a fraction every frame throws that fraction away and
    // the scroll position never actually advances. Keep our own
    // full-precision running position instead, and only ever write it out.
    var scrollPos = viewport.scrollLeft;

    function step(timestamp) {
      if (lastFrame == null) lastFrame = timestamp;
      var delta = (timestamp - lastFrame) / 1000;
      lastFrame = timestamp;

      if (isPaused || isDragging) {
        scrollPos = viewport.scrollLeft;
      } else {
        scrollPos += pxPerSecond * delta;
        if (halfWidth > 0) {
          if (scrollPos >= halfWidth) scrollPos -= halfWidth;
          else if (scrollPos < 0) scrollPos += halfWidth;
        }
        viewport.scrollLeft = scrollPos;
      }
      requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  });

  document.querySelectorAll('[data-auto-reveal]').forEach(function (panel) {
    if (!('IntersectionObserver' in window)) {
      panel.classList.add('is-visible');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.25 });
    io.observe(panel);
  });

  document.querySelectorAll('[data-file-input]').forEach(function (input) {
    input.addEventListener('change', function () {
      var wrap = input.closest('.aurajex-tml-submit__filewrap');
      var label = wrap.querySelector('[data-file-name]');
      label.textContent = input.files && input.files.length ? input.files[0].name : label.dataset.defaultText;
    });
  });

  document.querySelectorAll('.aurajex-tml-submit__form').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var status = form.querySelector('[data-submit-status]');
      var button = form.querySelector('.aurajex-tml-submit__button');
      var endpoint = form.getAttribute('data-ajax-endpoint');
      var formData = new FormData(form);

      button.disabled = true;
      status.hidden = false;
      status.textContent = status.dataset.sendingText;

      fetch(endpoint, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Request failed');
          status.textContent = status.dataset.successText;
          form.reset();
          var fileName = form.querySelector('[data-file-name]');
          if (fileName) fileName.textContent = fileName.dataset.defaultText;
        })
        .catch(function () {
          status.textContent = status.dataset.errorText;
        })
        .finally(function () {
          button.disabled = false;
        });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tel-input]').forEach(function (input) {
    var select = document.querySelector('[data-country-code][data-tel-target="' + input.id + '"]');
    if (!select) return;
    var form = input.closest('form');
    if (!form) return;

    // Combine the chosen dial code with whatever the customer typed, right
    // before the native Shopify contact form actually submits. Doesn't touch
    // the input's name attribute, so this stays fully compatible with
    // Shopify's own native "contact" form handling.
    form.addEventListener('submit', function () {
      var raw = input.value.trim();
      if (raw === '') return; // optional field left blank, nothing to prefix
      if (raw.charAt(0) === '+') return; // already a full international number, don't double-prefix
      input.value = select.value + raw;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
